import darkColorScheme from './token-groups/color.dark.json.js';
import depth from './token-groups/depth.json.js';
import legacyTokens from './token-groups/legacy-tokens.json.js';
import lightColorScheme from './token-groups/color.light.json.js';
import motion from './token-groups/motion.json.js';
import shape from './token-groups/shape.json.js';
import spacing from './token-groups/spacing.json.js';
import typography from './token-groups/typography.json.js';
import zIndex from './token-groups/z-index.json.js';
import { tokensToRems } from './utilities.js';

/**
 * Values to convert to CSS custom properties.
 * @example {background: '#000'} // --p-background: #000;
 */

const osColorSchemes = {
  light: 'light',
  dark: 'dark'
};
/**
 * Polaris color schemes and their associated color tokens.
 */

const colorSchemes = {
  light: lightColorScheme,
  dark: darkColorScheme
};
const tokens = {
  colorSchemes,
  depth,
  legacyTokens: tokensToRems(legacyTokens),
  motion,
  shape: tokensToRems(shape),
  spacing: tokensToRems(spacing),
  typography: tokensToRems(typography),
  zIndex
};

export { osColorSchemes, tokens };
